import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography, Button, Dropdown, DropdownMenuItem} from 'views/components';
import {Translate} from 'views/module';

const Content = (props) => {
  const [newBillingPeriod, setNewBillingPeriod] = React.useState('WEEKLY');
  const [isSaving, setIsSaving] = React.useState(false);

  const clientPaymentPlan = props.clientPaymentPlan;
  const updateClientBillingPeriod = props.updateClientBillingPeriod;
  const setViewMode = props.setViewMode;

  React.useEffect(() => {
    setNewBillingPeriod(clientPaymentPlan?.billingPeriod || 'WEEKLY');
  }, [clientPaymentPlan]);

  const onSave = () => {
    setIsSaving(true);
    const onSuccess = () => {
      setIsSaving(false);
      setViewMode();
    };
    updateClientBillingPeriod(newBillingPeriod, onSuccess);
  };

  return (
    <Stack
      direction={'column'}
      spacing={1}
      sx={{
        'display': 'flex',
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: '10px',
          }}
        >
          <Translate
            expression='client.ClientDetail.Payment.PaymentPlan.BillingPeriodTitle'
          />
        </Typography>
      </Box>
      <Box>
        <Dropdown
          value={newBillingPeriod}
          onChange={setNewBillingPeriod}
        >
          <DropdownMenuItem value={'WEEKLY'}>
            <Translate expression='client.ClientDetail.Payment.PaymentPlan.BillingPeriod.Options.WEEKLY' />
          </DropdownMenuItem>
          <DropdownMenuItem value={'MONTHLY'}>
            <Translate expression='client.ClientDetail.Payment.PaymentPlan.BillingPeriod.Options.MONTHLY' />
          </DropdownMenuItem>
        </Dropdown>
      </Box>
      <Stack
        direction={'row'}
        spacing={1}
        sx={{
        }}
      >
        <Button
          variant='outlined'
          onClick={setViewMode}
        >
          <Translate expression='generic.Cancel' />
        </Button>
        <Button
          loading={isSaving}
          onClick={onSave}
        >
          <Translate expression='generic.Save' />
        </Button>
      </Stack>
    </Stack>
  );
};

Content.propTypes = {
  clientPaymentPlan: PropTypes.object.isRequired,
  updateClientBillingPeriod: PropTypes.func.isRequired,
  setViewMode: PropTypes.func.isRequired,
};
export default React.memo(Content);
